import React, { useEffect } from "react";
import {
  colorLelyRed,
  colorLelyRedDark,
} from "../../containers/Admin/FarmFeaturesPage/FarmFeaturesPage";
import { measureResponsive } from "../../components/VirtualFarm/util";
import { IS_CLICKABLE_CSS_CLASSNAME } from "../../common/constants";
import { ADULT_THEME_CODE } from "../../common/constants";

/** Tractor component */
function Tractor({
  lineColor = colorLelyRedDark,
  mainColor = colorLelyRed,
  isClickable,
  farmTheme,
  isAdultSelected,
}) {
  useEffect(() => {}, [lineColor, mainColor]);
  return (
    <div
      style={{
        left: measureResponsive(73.2008),
        width: measureResponsive(10.5455),
        top: measureResponsive(7.32735),
        height: measureResponsive(9.3928777),
        position: "fixed",
      }}
      className={isClickable ? IS_CLICKABLE_CSS_CLASSNAME : ""}
    >
      {isAdultSelected ? (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          height="100%"
          width="100%"
          preserveAspectRatio="none"
          viewBox="0 0 187 158"
          fill="none"
        >
          <path
            d="M90.0339 111.265L136.784 99.5149L102.034 67.2649L36.7839 54.2649L60.0339 95.2649L90.0339 111.265Z"
            fill="white"
            stroke="black"
            stroke-width="3"
            stroke-linejoin="round"
          />
          <path
            d="M155.409 102.765L127.534 118.765L121.284 114.515L148.659 97.5149L155.409 102.765Z"
            fill="white"
            stroke="black"
            stroke-width="3"
            stroke-linejoin="round"
          />
          <mask id="path-3-inside-1_473_67305" fill="white">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M175.906 116.669C177.685 115.539 178.996 113.832 179.665 111.559C182.113 103.242 175.053 90.5024 163.897 83.103C155.429 77.4869 147.035 76.5615 142.411 80.0777L129.405 86.4394L162.032 124.593L175.936 116.702L175.906 116.669Z"
            />
          </mask>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M175.906 116.669C177.685 115.539 178.996 113.832 179.665 111.559C182.113 103.242 175.053 90.5024 163.897 83.103C155.429 77.4869 147.035 76.5615 142.411 80.0777L129.405 86.4394L162.032 124.593L175.936 116.702L175.906 116.669Z"
            fill="white"
          />
          <path
            d="M179.665 111.559L182.604 111.801L179.665 111.559ZM175.906 116.669L174.601 114.319C173.781 114.84 173.174 115.642 172.944 116.51C172.714 117.378 172.884 118.222 173.409 118.815L175.906 116.669ZM163.897 83.103L161.834 85.6264L161.834 85.6264L163.897 83.103ZM142.411 80.0777L143.332 82.6429C143.564 82.5294 143.787 82.3922 143.995 82.234L142.411 80.0777ZM129.405 86.4394L128.483 83.8742C127.557 84.3274 126.824 85.1398 126.509 86.0636C126.193 86.9874 126.332 87.913 126.884 88.5579L129.405 86.4394ZM162.032 124.593L159.51 126.712C160.322 127.661 161.839 127.799 163.167 127.046L162.032 124.593ZM175.936 116.702L177.071 119.155C177.943 118.66 178.607 117.847 178.873 116.95C179.139 116.053 178.977 115.171 178.433 114.556L175.936 116.702ZM176.726 111.316C176.272 112.857 175.493 113.752 174.601 114.319L177.212 119.02C179.878 117.326 181.719 114.806 182.604 111.801L176.726 111.316ZM161.834 85.6264C167.117 89.1305 171.429 93.906 174.111 98.745C176.857 103.701 177.633 108.235 176.726 111.316L182.604 111.801C184.145 106.566 182.615 100.572 179.654 95.229C176.628 89.7692 171.833 84.475 165.959 80.5797L161.834 85.6264ZM143.995 82.234C145.204 81.3142 147.399 80.6389 150.711 81.0769C153.952 81.5054 157.817 82.9623 161.834 85.6264L165.959 80.5797C161.509 77.6277 156.943 75.8138 152.714 75.2546C148.556 74.7049 144.241 75.3249 140.826 77.9213L143.995 82.234ZM130.327 89.0046L143.332 82.6429L141.489 77.5124L128.483 83.8742L130.327 89.0046ZM164.553 122.475L131.926 84.3208L126.884 88.5579L159.51 126.712L164.553 122.475ZM174.801 114.25L160.896 122.141L163.167 127.046L177.071 119.155L174.801 114.25ZM173.409 118.815L173.439 118.848L178.433 114.556L178.404 114.523L173.409 118.815Z"
            fill="black"
            mask="url(#path-3-inside-1_473_67305)"
          />
          <path
            d="M165.989 118.065C164.96 121.56 162.037 123.736 157.7 124.028C153.4 124.318 147.961 122.71 142.435 119.045C136.91 115.38 132.455 110.427 129.702 105.459C126.926 100.449 126.03 95.7394 127.059 92.2447C128.087 88.75 131.011 86.5735 135.348 86.2813C139.648 85.9915 145.087 87.6 150.613 91.2647C156.138 94.9295 160.593 99.8831 163.345 104.851C166.122 109.861 167.018 114.57 165.989 118.065Z"
            fill="white"
            stroke="black"
            stroke-width="3"
            stroke-linejoin="round"
          />
          <path
            d="M158.052 114.56C157.594 116.116 156.242 117.236 153.984 117.388C151.762 117.538 148.909 116.706 145.985 114.766C143.06 112.827 140.729 110.221 139.307 107.654C137.861 105.045 137.503 102.79 137.961 101.235C138.419 99.6788 139.771 98.5585 142.029 98.4063C144.251 98.2566 147.104 99.0891 150.028 101.029C152.953 102.968 155.284 105.574 156.706 108.14C158.152 110.749 158.51 113.004 158.052 114.56Z"
            fill="white"
            stroke="black"
            stroke-width="3"
            stroke-linejoin="round"
          />
          <path
            d="M133.254 85.8491C128.647 85.164 123.563 89.6417 121.596 91.9662C123.853 87.5619 130.686 77.7624 139.967 73.7986C149.248 69.8348 161.319 76.592 166.195 80.4662L147.491 90.6816C144.664 89.3562 137.86 86.5343 133.254 85.8491Z"
            fill="white"
            stroke="black"
            stroke-width="3"
            stroke-linejoin="round"
          />
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M101.975 40.923C102.384 39.9698 103.836 39.2649 105.565 39.2649C107.294 39.2649 108.746 39.9698 109.154 40.923L109.269 40.923L109.269 60.9358C109.269 62.1531 107.611 63.1399 105.565 63.1399C103.52 63.1399 101.861 62.1531 101.861 60.9358L101.861 41.4946C101.861 41.4861 101.861 41.4775 101.861 41.469C101.861 41.4604 101.861 41.4519 101.861 41.4433L101.861 40.923L101.975 40.923Z"
            fill="white"
          />
          <path
            d="M101.975 40.923L101.975 42.423C102.576 42.423 103.118 42.0652 103.354 41.5135L101.975 40.923ZM109.154 40.923L107.776 41.5135C108.012 42.0652 108.554 42.423 109.154 42.423L109.154 40.923ZM109.269 40.923L110.769 40.923C110.769 40.5251 110.611 40.1436 110.33 39.8623C110.049 39.581 109.667 39.423 109.269 39.423L109.269 40.923ZM109.269 60.9358L107.769 60.9358V60.9358H109.269ZM101.861 60.9358H103.361V60.9358L101.861 60.9358ZM101.861 41.4946L103.361 41.4946C103.361 41.485 103.361 41.4755 103.361 41.4659L101.861 41.4946ZM101.861 41.4433L103.361 41.4721C103.361 41.4625 103.361 41.4529 103.361 41.4433L101.861 41.4433ZM101.861 40.923L101.861 39.423C101.033 39.423 100.361 40.0946 100.361 40.923L101.861 40.923ZM103.354 41.5135C103.363 41.4927 103.477 41.2983 103.911 41.0947C104.321 40.903 104.895 40.7649 105.565 40.7649V37.7649C104.506 37.7649 103.49 37.9792 102.638 38.3783C101.812 38.7654 100.996 39.4001 100.597 40.3325L103.354 41.5135ZM105.565 40.7649C106.235 40.7649 106.809 40.903 107.218 41.0947C107.653 41.2983 107.767 41.4927 107.776 41.5135L110.533 40.3324C110.134 39.4 109.318 38.7654 108.492 38.3782C107.64 37.9792 106.624 37.7649 105.565 37.7649V40.7649ZM109.154 42.423L109.269 42.423L109.269 39.423L109.154 39.423L109.154 42.423ZM107.769 40.923L107.769 60.9358L110.769 60.9358L110.769 40.923L107.769 40.923ZM107.769 60.9358C107.769 60.8043 107.85 60.9478 107.417 61.2053C107.016 61.4438 106.365 61.6399 105.565 61.6399V64.6399C106.811 64.6399 108.012 64.3425 108.951 63.7833C109.859 63.2431 110.769 62.2845 110.769 60.9358H107.769ZM105.565 61.6399C104.765 61.6399 104.114 61.4438 103.713 61.2053C103.28 60.9478 103.361 60.8043 103.361 60.9358H100.361C100.361 62.2845 101.271 63.2431 102.179 63.7833C103.119 64.3425 104.319 64.6399 105.565 64.6399V61.6399ZM103.361 60.9358L103.361 41.4946L100.361 41.4946L100.361 60.9358L103.361 60.9358ZM103.361 41.4659C103.361 41.4669 103.361 41.4679 103.361 41.469H100.361C100.361 41.4871 100.361 41.5052 100.361 41.5233L103.361 41.4659ZM103.361 41.469C103.361 41.47 103.361 41.471 103.361 41.4721L100.361 41.4146C100.361 41.4327 100.361 41.4508 100.361 41.469H103.361ZM103.361 41.4433L103.361 40.923L100.361 40.923L100.361 41.4434L103.361 41.4433ZM101.861 42.423L101.975 42.423L101.975 39.423L101.861 39.423L101.861 42.423Z"
            fill="black"
          />
          <path
            d="M105.333 42.1386C106.216 42.1386 106.95 41.7605 107.103 41.2617C107.141 41.1375 107.106 41.0074 107.063 40.8849C106.661 39.7458 106.391 37.5032 107.839 36.3736C108.146 36.1341 108.384 35.7938 108.384 35.4045V34.7045C108.384 34.0721 107.803 33.6198 107.252 33.9312C105.598 34.867 103.534 37.169 103.534 41.0679C103.534 41.6592 104.339 42.1386 105.333 42.1386Z"
            fill="black"
          />
          <path
            d="M36.4088 53.5149L33.1588 27.0149C48.0416 30.0412 55.7139 35.0131 67.9088 47.1399L101.409 28.0149L103.534 67.7649L73.6588 84.7649L59.2838 76.7649L36.4088 53.5149Z"
            fill="white"
          />
          <path
            d="M67.9088 47.1399C55.7139 35.0131 48.0416 30.0412 33.1588 27.0149L36.4088 53.5149L59.2838 76.7649L73.6588 84.7649M67.9088 47.1399L73.6588 84.7649M67.9088 47.1399L101.409 28.0149L103.534 67.7649L73.6588 84.7649"
            stroke="#121212"
            stroke-width="3"
            stroke-linejoin="round"
          />
          <path
            d="M73.6588 84.2649L67.9088 47.9429L101.409 28.5149L103.534 67.8536L73.6588 84.2649Z"
            fill="white"
            stroke="black"
            stroke-width="3"
            stroke-linejoin="round"
          />
          <path
            d="M69.4088 48.6456C46.884 32.2511 39.4025 30.4128 28.6588 29.8955L64.7838 8.39555C79.0956 7.92809 96.7841 21.9693 103.659 30.0205L69.4088 48.6456Z"
            fill="white"
            stroke="black"
            stroke-width="3"
            stroke-linejoin="bevel"
          />
          <mask id="path-15-inside-2_473_67305" fill="white">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M53.8686 101.37C55.642 100.301 56.9384 98.6817 57.5838 96.5243C59.9385 88.6528 52.7361 76.594 41.4967 69.5902C32.7759 64.1559 24.1871 63.3616 19.6758 66.9554L9.24774 70.9888L18.3374 82.1278C20.4775 86.8052 24.306 91.5882 29.2127 95.455L40.1532 108.862L53.9086 101.412L53.8686 101.37Z"
            />
          </mask>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M53.8686 101.37C55.642 100.301 56.9384 98.6817 57.5838 96.5243C59.9385 88.6528 52.7361 76.594 41.4967 69.5902C32.7759 64.1559 24.1871 63.3616 19.6758 66.9554L9.24774 70.9888L18.3374 82.1278C20.4775 86.8052 24.306 91.5882 29.2127 95.455L40.1532 108.862L53.9086 101.412L53.8686 101.37Z"
            fill="white"
          />
          <path
            d="M57.5838 96.5243L60.5187 96.7805L57.5838 96.5243ZM53.8686 101.37L52.6426 98.9706C51.7849 99.4878 51.1456 100.312 50.9072 101.208C50.6687 102.104 50.8572 102.973 51.4189 103.568L53.8686 101.37ZM41.4967 69.5902L43.505 67.0318L41.4967 69.5902ZM19.6758 66.9554L20.2956 69.6527C20.6642 69.5101 21.0156 69.3077 21.3321 69.0555L19.6758 66.9554ZM9.24774 70.9888L8.62796 68.2915C7.63243 68.6766 6.80387 69.4808 6.41641 70.4382C6.02896 71.3955 6.13311 72.3812 6.6944 73.069L9.24774 70.9888ZM18.3374 82.1278L21.1858 80.5224C21.1074 80.3511 21.0085 80.192 20.8907 80.0476L18.3374 82.1278ZM29.2127 95.455L31.766 93.3748C31.6652 93.2512 31.5509 93.139 31.4246 93.0394L29.2127 95.455ZM40.1532 108.862L37.5999 110.942C38.3857 111.905 39.8855 112.075 41.2196 111.353L40.1532 108.862ZM53.9086 101.412L54.975 103.903C55.8807 103.413 56.5746 102.58 56.8469 101.657C57.1192 100.734 56.9381 99.8284 56.3583 99.2143L53.9086 101.412ZM54.649 96.268C54.2397 97.6363 53.5234 98.4395 52.6426 98.9706L55.0946 103.77C57.7606 102.162 59.6372 99.7272 60.5187 96.7805L54.649 96.268ZM39.4883 72.1486C44.8153 75.4681 49.1752 79.9859 51.9022 84.5516C54.7061 89.246 55.4857 93.471 54.649 96.268L60.5187 96.7805C62.0367 91.706 60.3924 85.9659 57.3739 80.9121C54.2785 75.7296 49.4174 70.7161 43.505 67.0318L39.4883 72.1486ZM21.3321 69.0555C22.4753 68.1448 24.6598 67.4215 28.0605 67.805C31.3725 68.1784 35.3483 69.5688 39.4883 72.1486L43.505 67.0318C38.9243 64.1773 34.2454 62.4533 29.9549 61.9695C25.7532 61.4957 21.3877 62.1721 18.0194 64.8553L21.3321 69.0555ZM9.86752 73.6861L20.2956 69.6527L19.056 64.2581L8.62796 68.2915L9.86752 73.6861ZM20.8907 80.0476L11.8011 68.9087L6.6944 73.069L15.784 84.2079L20.8907 80.0476ZM31.4246 93.0394C26.7538 89.3586 23.1609 84.8392 21.1858 80.5224L15.4889 83.7331C17.7941 88.7713 21.8583 93.8179 27.0008 97.8705L31.4246 93.0394ZM42.7065 106.782L31.766 93.3748L26.6593 97.5351L37.5999 110.942L42.7065 106.782ZM52.8422 98.9217L39.0868 106.371L41.2196 111.353L54.975 103.903L52.8422 98.9217ZM51.4189 103.568L51.4589 103.611L56.3583 99.2143L56.3183 99.1719L51.4189 103.568Z"
            fill="black"
            mask="url(#path-15-inside-2_473_67305)"
          />
          <path
            d="M44.0545 102.334C43.0196 105.85 40.1423 108.054 35.9216 108.412C31.7309 108.767 26.4429 107.255 21.084 103.701C15.7251 100.147 11.4199 95.2959 8.77325 90.4059C6.10757 85.4808 5.25599 80.8033 6.29091 77.2875C7.32583 73.7717 10.2031 71.5673 14.4239 71.2096C18.6146 70.8544 23.9025 72.3663 29.2614 75.9205C34.6203 79.4748 38.9255 84.3254 41.5722 89.2155C44.2379 94.1406 45.0894 98.818 44.0545 102.334Z"
            fill="white"
            stroke="black"
            stroke-width="3"
            stroke-linejoin="round"
          />
          <path
            d="M33.4521 96.4067C33.0639 97.7256 31.9037 98.7169 29.8993 98.852C27.9317 98.9846 25.3947 98.2469 22.7881 96.5181C20.1815 94.7893 18.1099 92.4704 16.8504 90.1974C15.5674 87.882 15.2745 85.9269 15.6627 84.608C16.0509 83.2891 17.2111 82.2978 19.2155 82.1628C21.1831 82.0302 23.7201 82.7678 26.3267 84.4966C28.9333 86.2254 31.0049 88.5443 32.2644 90.8173C33.5474 93.1327 33.8403 95.0878 33.4521 96.4067Z"
            fill="white"
            stroke="black"
            stroke-width="3"
            stroke-linejoin="round"
          />
          <path
            d="M29.0338 72.1399C20.3055 67.6964 10.3254 67.8066 7.03375 69.6399C7.03375 69.6399 8.48822 64.358 11.2382 60.5016C13.9882 56.6452 19.4088 53.7649 19.4088 53.7649C19.4088 53.7649 25.7838 51.0149 33.7838 53.7649C51.7319 59.9346 59.0338 76.7649 61.5338 82.7649L54.317 86.9978L50.2838 89.5149C45.7838 83.8899 42.7838 79.1399 29.0338 72.1399Z"
            fill="white"
            stroke="black"
            stroke-width="3"
            stroke-linejoin="round"
          />
          <path
            d="M84.1588 76.866V61.8899L94.599 55.0015C95.6586 54.3024 96.9866 54.1463 98.1768 54.5877C112.605 59.938 128.008 66.4535 158.784 85.0149L156.029 107.055C155.874 108.291 155.154 109.383 154.079 110.012L142.534 116.765C120.086 107.81 108.472 100.541 85.4847 79.8375C84.6454 79.0816 84.1588 77.9956 84.1588 76.866Z"
            fill="white"
          />
          <path
            d="M84.1588 61.8899V76.866C84.1588 77.9956 84.6454 79.0816 85.4847 79.8375C108.472 100.541 120.086 107.81 142.534 116.765M84.1588 61.8899L94.599 55.0015C95.6586 54.3024 96.9866 54.1463 98.1768 54.5877C112.605 59.938 128.008 66.4535 158.784 85.0149M84.1588 61.8899C99.6588 76.2649 115.409 85.7649 138.284 98.5149M158.784 85.0149L138.284 98.5149M158.784 85.0149L156.029 107.055C155.874 108.291 155.154 109.383 154.079 110.012L142.534 116.765M138.284 98.5149L142.534 116.765"
            stroke="black"
            stroke-width="3"
            stroke-linejoin="round"
          />
          <path
            d="M157.847 92.5774L157.097 98.5149L153.409 100.556L146.221 104.451L140.284 107.451L134.096 104.451L133.721 101.139L139.284 103.076L144.334 100.556L153.409 95.389L157.847 92.5774Z"
            fill="#F7F6F4"
          />
          <path
            d="M139.284 103.076L140.284 107.451M139.284 103.076L133.721 101.139L134.096 104.451L140.284 107.451M139.284 103.076L144.334 100.556M140.284 107.451L146.221 104.451M144.334 100.556L146.221 104.451M144.334 100.556L153.409 95.389M146.221 104.451L153.409 100.556M153.409 95.389L157.847 92.5774L157.097 98.5149L153.409 100.556M153.409 95.389V100.556"
            stroke="black"
            stroke-width="3"
            stroke-linejoin="round"
          />
          <mask id="path-24-inside-3_473_67305" fill="white">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M129.149 143.547C131.707 142.41 133.597 140.37 134.465 137.467C136.963 129.118 130.064 116.788 119.056 109.929C110.524 104.612 102.028 104.142 97.4747 108.088L97.242 107.842L85.5184 112.368L96.833 126.199C98.8579 130.068 101.914 133.862 105.695 137.032L116.583 150.341L129.149 143.547Z"
            />
          </mask>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M129.149 143.547C131.707 142.41 133.597 140.37 134.465 137.467C136.963 129.118 130.064 116.788 119.056 109.929C110.524 104.612 102.028 104.142 97.4747 108.088L97.242 107.842L85.5184 112.368L96.833 126.199C98.8579 130.068 101.914 133.862 105.695 137.032L116.583 150.341L129.149 143.547Z"
            fill="white"
          />
          <path
            d="M134.465 137.467L137.4 137.724L134.465 137.467ZM129.149 143.547L128.355 140.922C128.264 140.963 128.174 141.007 128.085 141.055L129.149 143.547ZM119.056 109.929L121.065 107.371L119.056 109.929ZM97.4747 108.088L95.0269 110.288C96.0273 111.345 97.9074 111.253 99.26 110.081L97.4747 108.088ZM97.242 107.842L99.6898 105.642C98.9781 104.89 97.7844 104.696 96.6244 105.144L97.242 107.842ZM85.5184 112.368L84.9008 109.67C83.9042 110.055 83.0746 110.86 82.6869 111.818C82.2993 112.776 82.4041 113.763 82.9668 114.451L85.5184 112.368ZM96.833 126.199L99.6295 124.488C99.5603 124.356 99.4784 124.232 99.3847 124.117L96.833 126.199ZM105.695 137.032L108.246 134.949C108.16 134.844 108.064 134.747 107.959 134.659L105.695 137.032ZM116.583 150.341L114.031 152.423C114.817 153.383 116.314 153.553 117.646 152.833L116.583 150.341ZM131.53 137.211C130.951 139.148 129.837 140.263 128.355 140.922L129.942 146.172C133.577 144.556 136.243 141.592 137.4 137.724L131.53 137.211ZM117.048 112.487C122.233 115.719 126.451 120.246 129.058 124.905C131.723 129.668 132.459 134.107 131.53 137.211L137.4 137.724C138.969 132.478 137.504 126.577 134.592 121.373C131.622 116.066 126.887 110.999 121.065 107.371L117.048 112.487ZM99.26 110.081C100.485 109.02 102.657 108.211 105.929 108.463C109.15 108.71 113.021 109.978 117.048 112.487L121.065 107.371C116.559 104.563 111.917 102.938 107.618 102.608C103.37 102.281 99.0177 103.211 95.6893 106.095L99.26 110.081ZM94.7942 110.042L95.0269 110.288L99.9225 105.888L99.6898 105.642L94.7942 110.042ZM86.136 115.067L97.8596 110.54L96.6244 105.144L84.9008 109.67L86.136 115.067ZM99.3847 124.117L88.0701 110.286L82.9668 114.451L94.2814 128.281L99.3847 124.117ZM107.959 134.659C104.383 131.661 101.513 128.087 99.6295 124.488L94.0366 127.911C96.2028 132.05 99.4444 136.063 103.431 139.405L107.959 134.659ZM119.134 148.258L108.246 134.949L103.143 139.114L114.031 152.423L119.134 148.258ZM128.085 141.055L115.519 147.849L117.646 152.833L130.213 146.039L128.085 141.055Z"
            fill="black"
            mask="url(#path-24-inside-3_473_67305)"
          />
          <path
            d="M120.54 143.812C119.505 147.328 116.628 149.533 112.407 149.89C108.217 150.246 102.929 148.734 97.5698 145.179C92.2109 141.625 87.9058 136.774 85.2591 131.884C82.5934 126.959 81.7418 122.282 82.7767 118.766C83.8116 115.25 86.6889 113.046 90.9097 112.688C95.1004 112.333 100.388 113.845 105.747 117.399C111.106 120.953 115.411 125.804 118.058 130.694C120.724 135.619 121.575 140.297 120.54 143.812Z"
            fill="white"
            stroke="black"
            stroke-width="3"
            stroke-linejoin="round"
          />
          <path
            d="M111 138.939C110.543 140.494 109.19 141.615 106.932 141.767C104.71 141.917 101.857 141.084 98.9329 139.145C96.0085 137.205 93.6774 134.599 92.2553 132.033C90.8097 129.424 90.4511 127.169 90.909 125.613C91.367 124.057 92.7192 122.937 94.9775 122.785C97.1992 122.635 100.052 123.468 102.977 125.407C105.901 127.347 108.232 129.953 109.654 132.519C111.1 135.128 111.458 137.383 111 138.939Z"
            fill="white"
            stroke="black"
            stroke-width="3"
            stroke-linejoin="round"
          />
          <path
            d="M93.6783 109.148C89.0719 108.463 83.9874 112.94 82.0209 115.265C82.7218 111.921 85.9644 101.522 100.392 97.0973C109.888 94.1848 121.744 99.8907 126.619 103.765L107.915 113.98C105.089 112.655 98.2846 109.833 93.6783 109.148Z"
            fill="white"
            stroke="black"
            stroke-width="3"
            stroke-linejoin="round"
          />
        </svg>
      ) : (
        <svg
          height="100%"
          width="100%"
          preserveAspectRatio="none"
          viewBox="0 0 320 262"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g filter="url(#filter0_d)">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M172.629 52.5153L169.569 54.2687L170.02 62.9134C170.139 62.8577 170.262 62.8056 170.388 62.7574C171.081 56.2343 174.782 53.0029 176.726 52.5154V56.7149C174.717 57.8629 174.392 60.4983 174.597 62.636C176.359 63.1864 177.594 64.4678 177.594 65.9606C177.594 66.2157 177.558 66.4645 177.49 66.7046H177.595L177.595 91.3082C177.595 92.7535 176.437 94.0006 174.764 94.578C188.626 100.067 204.135 107.022 225.465 118.596C227.164 117.341 228.979 116.225 230.91 115.299C244.759 108.662 266.862 119.977 276.183 126.464L271.155 129.632C271.874 130.031 272.597 130.447 273.323 130.879C294.149 143.269 310.096 164.602 308.941 178.527C308.626 182.333 307.065 185.192 304.538 187.084L304.597 187.14L287.662 198.286C281.372 204.745 266.755 203.304 250.297 193.513C246.825 191.447 243.485 189.137 240.334 186.657L234.7 189.973C232.015 188.902 229.435 187.842 226.945 186.786L218.2 191.806C228.7 202.696 235.294 215.01 234.537 224.14C234.222 227.946 232.661 230.805 230.134 232.697L230.193 232.753L213.259 243.899C206.968 250.357 192.351 248.917 175.893 239.125C154.658 226.492 138.399 204.741 139.576 190.543C139.804 187.787 140.673 185.519 142.079 183.745L140.762 183.043L137.394 184.954C137.734 184.053 138.074 183.188 138.414 182.358L120.839 192.001V192.022L120.818 192.012L120.801 192.022L99.4418 182.091C98.1999 181.514 97.3397 180.342 97.1619 178.984L96.7316 175.697L83.0493 183.632C76.4039 189.725 61.892 187.462 46.0127 176.756C25.5256 162.944 10.5205 140.309 12.4979 126.2C13.0071 122.566 14.5927 119.853 17.0163 118.062L16.9334 117.973L17.6598 117.621C18.4197 117.137 19.2514 116.735 20.1485 116.414L34.828 109.293C24.5667 106.465 15.298 106.934 11.3059 109.158L20.9771 94.1394L33.5327 85.7019C33.5327 85.7019 42.956 81.1951 56.0667 85.7019C58.2536 86.4536 60.3553 87.3019 62.3742 88.2323L57.9649 53.6363C55.2912 53.0967 52.5628 52.6665 49.7162 52.3105V46.3697L50.0594 46.3703L108.919 11.3395C132.253 10.5773 161.064 33.3478 172.453 46.5743L172.629 46.5746V52.5153ZM213.861 180.871C208.551 178.301 203.585 175.662 198.746 172.844L194.672 174.13C196.07 174.853 197.488 175.64 198.919 176.492C202.551 178.652 206.033 181.084 209.303 183.702L213.861 180.871Z"
              fill="green"
            />
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M172.629 52.5153L169.569 54.2687L170.02 62.9134C170.139 62.8577 170.262 62.8056 170.388 62.7574C171.081 56.2343 174.782 53.0029 176.726 52.5154V56.7149C174.717 57.8629 174.392 60.4983 174.597 62.636C176.359 63.1864 177.594 64.4678 177.594 65.9606C177.594 66.2157 177.558 66.4645 177.49 66.7046H177.595L177.595 91.3082C177.595 92.7535 176.437 94.0006 174.764 94.578C188.626 100.067 204.135 107.022 225.465 118.596C227.164 117.341 228.979 116.225 230.91 115.299C244.759 108.662 266.862 119.977 276.183 126.464L271.155 129.632C271.874 130.031 272.597 130.447 273.323 130.879C294.149 143.269 310.096 164.602 308.941 178.527C308.626 182.333 307.065 185.192 304.538 187.084L304.597 187.14L287.662 198.286C281.372 204.745 266.755 203.304 250.297 193.513C246.825 191.447 243.485 189.137 240.334 186.657L234.7 189.973C232.015 188.902 229.435 187.842 226.945 186.786L218.2 191.806C228.7 202.696 235.294 215.01 234.537 224.14C234.222 227.946 232.661 230.805 230.134 232.697L230.193 232.753L213.259 243.899C206.968 250.357 192.351 248.917 175.893 239.125C154.658 226.492 138.399 204.741 139.576 190.543C139.804 187.787 140.673 185.519 142.079 183.745L140.762 183.043L137.394 184.954C137.734 184.053 138.074 183.188 138.414 182.358L120.839 192.001V192.022L120.818 192.012L120.801 192.022L99.4418 182.091C98.1999 181.514 97.3397 180.342 97.1619 178.984L96.7316 175.697L83.0493 183.632C76.4039 189.725 61.892 187.462 46.0127 176.756C25.5256 162.944 10.5205 140.309 12.4979 126.2C13.0071 122.566 14.5927 119.853 17.0163 118.062L16.9334 117.973L17.6598 117.621C18.4197 117.137 19.2514 116.735 20.1485 116.414L34.828 109.293C24.5667 106.465 15.298 106.934 11.3059 109.158L20.9771 94.1394L33.5327 85.7019C33.5327 85.7019 42.956 81.1951 56.0667 85.7019C58.2536 86.4536 60.3553 87.3019 62.3742 88.2323L57.9649 53.6363C55.2912 53.0967 52.5628 52.6665 49.7162 52.3105V46.3697L50.0594 46.3703L108.919 11.3395C132.253 10.5773 161.064 33.3478 172.453 46.5743L172.629 46.5746V52.5153ZM213.861 180.871C208.551 178.301 203.585 175.662 198.746 172.844L194.672 174.13C196.07 174.853 197.488 175.64 198.919 176.492C202.551 178.652 206.033 181.084 209.303 183.702L213.861 180.871Z"
              stroke="white"
              stroke-width="20"
              stroke-linejoin="round"
            />
          </g>
          <path
            d="M150.3 188.129L226.916 163.956L169.966 111.104L63.0317 89.799L101.135 161.908L150.3 188.129Z"
            fill={mainColor}
            stroke={lineColor}
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            d="M150.3 188.129L226.916 163.956L169.966 111.104L63.0317 89.799L101.135 161.908L150.3 188.129Z"
            fill={mainColor}
            stroke={lineColor}
            stroke-width="2"
            stroke-linejoin="round"
          />
          <mask id="path-4-inside-1" fill="white">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M100.53 173.402C103.16 171.656 104.88 168.889 105.41 165.107C107.349 151.269 92.6327 129.07 72.54 115.523C57.2896 105.242 43.3252 102.899 36.6321 108.418L16.9333 117.973L79.7963 185.519L100.586 173.461L100.53 173.402Z"
            />
          </mask>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M100.53 173.402C103.16 171.656 104.88 168.889 105.41 165.107C107.349 151.269 92.6327 129.07 72.54 115.523C57.2896 105.242 43.3252 102.899 36.6321 108.418L16.9333 117.973L79.7963 185.519L100.586 173.461L100.53 173.402Z"
            fill="#CFCBC3"
          />
          <path
            d="M105.41 165.107L107.39 165.384L105.41 165.107ZM100.53 173.402L99.4236 171.736L97.4329 173.057L99.0846 174.784L100.53 173.402ZM72.54 115.523L73.658 113.865L72.54 115.523ZM36.6321 108.418L37.505 110.218L37.72 110.113L37.9044 109.961L36.6321 108.418ZM16.9333 117.973L16.0604 116.174L13.6255 117.355L15.4692 119.336L16.9333 117.973ZM79.7963 185.519L78.3322 186.882L79.4193 188.05L80.7997 187.249L79.7963 185.519ZM100.586 173.461L101.59 175.191L103.789 173.915L102.032 172.078L100.586 173.461ZM103.429 164.829C102.968 168.117 101.52 170.344 99.4236 171.736L101.636 175.068C104.8 172.968 106.791 169.662 107.39 165.384L103.429 164.829ZM71.4219 117.182C81.2522 123.809 89.7675 132.558 95.5699 141.311C101.427 150.147 104.296 158.64 103.429 164.829L107.39 165.384C108.462 157.736 104.943 148.211 98.9038 139.101C92.8097 129.908 83.9205 120.784 73.658 113.865L71.4219 117.182ZM37.9044 109.961C40.6019 107.737 45.0576 106.884 51.0048 108.011C56.9034 109.128 63.9558 112.148 71.4219 117.182L73.658 113.865C65.8738 108.617 58.3188 105.325 51.7493 104.081C45.2285 102.845 39.3555 103.58 35.3598 106.875L37.9044 109.961ZM17.8061 119.773L37.505 110.218L35.7593 106.619L16.0604 116.174L17.8061 119.773ZM81.2603 184.156L18.3973 116.61L15.4692 119.336L78.3322 186.882L81.2603 184.156ZM99.5829 171.731L78.7928 183.789L80.7997 187.249L101.59 175.191L99.5829 171.731ZM99.0846 174.784L99.141 174.843L102.032 172.078L101.975 172.019L99.0846 174.784Z"
            fill="#766E68"
            mask="url(#path-4-inside-1)"
          />
          <path
            d="M85.859 175.66C84.941 182.21 80.2213 185.726 72.9976 185.821C65.7981 185.916 56.2761 182.592 46.1514 175.766C36.0266 168.94 27.2974 159.959 21.3654 151.011C15.4134 142.032 12.4089 133.309 13.3269 126.759C14.2449 120.208 18.9646 116.693 26.1883 116.597C33.3878 116.502 42.9098 119.827 53.0346 126.653C63.1593 133.479 71.8885 142.46 77.8205 151.408C83.7725 160.387 86.7771 169.11 85.859 175.66Z"
            fill="#EFEDEA"
            stroke="#766E68"
            stroke-width="2"
          />
          <path
            d="M68.9603 165.463C68.4944 168.787 66.0829 170.661 62.2255 170.712C58.3923 170.763 53.2948 168.991 47.8546 165.323C42.4145 161.655 37.7432 156.841 34.5849 152.077C31.4065 147.283 29.8915 142.76 30.3574 139.436C30.8232 136.112 33.2348 134.238 37.0922 134.187C40.9254 134.136 46.0229 135.908 51.463 139.576C56.9031 143.244 61.5744 148.058 64.7328 152.822C67.9111 157.616 69.4262 162.138 68.9603 165.463Z"
            fill="#766E68"
            stroke="#766E68"
            stroke-width="2"
          />
          <mask id="path-8-inside-2" fill="white">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M100.53 173.402C103.16 171.656 104.88 168.889 105.41 165.107C107.349 151.269 92.6327 129.07 72.54 115.523C57.2896 105.242 43.3252 102.899 36.6321 108.418L16.9333 117.973L79.7963 185.519L100.586 173.461L100.53 173.402Z"
            />
          </mask>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M100.53 173.402C103.16 171.656 104.88 168.889 105.41 165.107C107.349 151.269 92.6327 129.07 72.54 115.523C57.2896 105.242 43.3252 102.899 36.6321 108.418L16.9333 117.973L79.7963 185.519L100.586 173.461L100.53 173.402Z"
            fill="#CFCBC3"
          />
          <path
            d="M105.41 165.107L107.39 165.384L105.41 165.107ZM100.53 173.402L99.4236 171.736L97.4329 173.057L99.0846 174.784L100.53 173.402ZM72.54 115.523L71.4219 117.182L72.54 115.523ZM36.6321 108.418L37.505 110.218L37.72 110.113L37.9044 109.961L36.6321 108.418ZM16.9333 117.973L16.0604 116.174L13.6255 117.355L15.4692 119.336L16.9333 117.973ZM79.7963 185.519L78.3322 186.882L79.4193 188.05L80.7997 187.249L79.7963 185.519ZM100.586 173.461L101.59 175.191L103.789 173.915L102.032 172.078L100.586 173.461ZM103.429 164.829C102.968 168.117 101.52 170.344 99.4236 171.736L101.636 175.068C104.8 172.968 106.791 169.662 107.39 165.384L103.429 164.829ZM71.4219 117.182C81.2522 123.809 89.7675 132.558 95.5699 141.311C101.427 150.147 104.296 158.64 103.429 164.829L107.39 165.384C108.462 157.736 104.943 148.211 98.9038 139.101C92.8097 129.908 83.9205 120.784 73.658 113.865L71.4219 117.182ZM37.9044 109.961C40.6018 107.737 45.0576 106.884 51.0048 108.011C56.9034 109.128 63.9558 112.148 71.4219 117.182L73.658 113.865C65.8738 108.617 58.3188 105.325 51.7493 104.081C45.2285 102.845 39.3555 103.58 35.3598 106.875L37.9044 109.961ZM17.8061 119.773L37.505 110.218L35.7593 106.619L16.0604 116.174L17.8061 119.773ZM81.2603 184.156L18.3973 116.61L15.4692 119.336L78.3322 186.882L81.2603 184.156ZM99.5829 171.731L78.7928 183.789L80.7997 187.249L101.59 175.191L99.5829 171.731ZM99.0846 174.784L99.141 174.843L102.032 172.078L101.975 172.019L99.0846 174.784Z"
            fill="#766E68"
            mask="url(#path-8-inside-2)"
          />
          <path
            d="M85.859 175.66C84.941 182.21 80.2213 185.726 72.9976 185.821C65.7981 185.916 56.2761 182.592 46.1514 175.766C36.0266 168.94 27.2974 159.959 21.3654 151.011C15.4134 142.032 12.4089 133.309 13.3269 126.759C14.2449 120.208 18.9646 116.693 26.1883 116.597C33.3878 116.502 42.9098 119.827 53.0346 126.653C63.1593 133.479 71.8885 142.46 77.8206 151.408C83.7725 160.387 86.7771 169.11 85.859 175.66Z"
            fill="#EFEDEA"
            stroke="#766E68"
            stroke-width="2"
          />
          <path
            d="M68.9603 165.463C68.4944 168.787 66.0829 170.661 62.2255 170.712C58.3923 170.763 53.2948 168.991 47.8546 165.323C42.4145 161.655 37.7432 156.841 34.5849 152.077C31.4065 147.283 29.8915 142.76 30.3574 139.436C30.8232 136.112 33.2348 134.238 37.0922 134.187C40.9254 134.136 46.0229 135.908 51.463 139.576C56.9031 143.244 61.5744 148.058 64.7328 152.822C67.9111 157.616 69.4262 162.138 68.9603 165.463Z"
            fill="#766E68"
            stroke="#766E68"
            stroke-width="2"
          />
          <path
            d="M257.439 169.283L211.756 195.504L201.514 188.539L246.377 160.679L257.439 169.283Z"
            fill="#766E68"
            stroke="#766E68"
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            d="M257.439 169.283L211.756 195.504L201.514 188.539L246.377 160.679L257.439 169.283Z"
            fill="#766E68"
            stroke="#766E68"
            stroke-width="2"
            stroke-linejoin="round"
          />
          <mask id="path-14-inside-3" fill="white">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M304.538 187.084C307.065 185.192 308.626 182.333 308.941 178.527C310.096 164.602 294.149 143.269 273.323 130.879C257.517 121.475 243.442 119.926 237.072 125.813L217.944 136.466L284.521 200.353L304.597 187.14L304.538 187.084Z"
            />
          </mask>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M304.538 187.084C307.065 185.192 308.626 182.333 308.941 178.527C310.096 164.602 294.149 143.269 273.323 130.879C257.517 121.475 243.442 119.926 237.072 125.813L217.944 136.466L284.521 200.353L304.597 187.14L304.538 187.084Z"
            fill="#CFCBC3"
          />
          <path
            d="M308.941 178.527L310.934 178.692L308.941 178.527ZM304.538 187.084L303.339 185.483L301.426 186.915L303.173 188.546L304.538 187.084ZM273.323 130.879L274.346 129.16L273.323 130.879ZM237.072 125.813L238.045 127.561L238.253 127.444L238.429 127.282L237.072 125.813ZM217.944 136.466L216.971 134.718L214.606 136.035L216.559 137.909L217.944 136.466ZM284.521 200.353L283.137 201.796L284.288 202.901L285.621 202.024L284.521 200.353ZM304.597 187.14L305.697 188.811L307.82 187.413L305.962 185.678L304.597 187.14ZM306.948 178.362C306.674 181.67 305.353 183.975 303.339 185.483L305.736 188.685C308.776 186.41 310.577 182.997 310.934 178.692L306.948 178.362ZM272.301 132.598C282.49 138.66 291.485 146.914 297.773 155.325C304.12 163.815 307.464 172.133 306.948 178.362L310.934 178.692C311.572 170.996 307.521 161.685 300.977 152.93C294.373 144.096 284.983 135.489 274.346 129.16L272.301 132.598ZM238.429 127.282C240.997 124.909 245.397 123.806 251.398 124.595C257.351 125.377 264.562 127.994 272.301 132.598L274.346 129.16C266.278 124.36 258.549 121.5 251.92 120.629C245.34 119.764 239.517 120.83 235.714 124.344L238.429 127.282ZM218.917 138.213L238.045 127.561L236.099 124.066L216.971 134.718L218.917 138.213ZM285.906 198.91L219.328 135.023L216.559 137.909L283.137 201.796L285.906 198.91ZM303.498 185.469L283.422 198.683L285.621 202.024L305.697 188.811L303.498 185.469ZM303.173 188.546L303.232 188.602L305.962 185.678L305.902 185.622L303.173 188.546Z"
            fill="#766E68"
            mask="url(#path-14-inside-3)"
          />
          <path
            d="M290.018 190.167C289.471 196.759 284.958 200.536 277.751 201.039C270.568 201.54 260.874 198.759 250.379 192.516C239.885 186.273 230.663 177.799 224.235 169.2C217.785 160.572 214.293 152.033 214.839 145.441C215.386 138.849 219.899 135.073 227.106 134.57C234.289 134.068 243.983 136.849 254.478 143.092C264.972 149.336 274.194 157.809 280.622 166.408C287.072 175.036 290.564 183.576 290.018 190.167Z"
            fill="#EFEDEA"
            stroke="#766E68"
            stroke-width="2"
          />
          <path
            d="M272.57 180.941C272.293 184.286 269.991 186.294 266.143 186.563C262.318 186.83 257.129 185.348 251.49 181.993C245.852 178.639 240.916 174.097 237.494 169.518C234.049 164.911 232.281 160.482 232.559 157.137C232.836 153.791 235.138 151.784 238.986 151.515C242.811 151.248 248 152.729 253.639 156.084C259.277 159.439 264.213 163.981 267.635 168.559C271.079 173.166 272.848 177.596 272.57 180.941Z"
            fill="#766E68"
            stroke="#766E68"
            stroke-width="2"
          />
          <mask id="path-18-inside-4" fill="white">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M304.538 187.084C307.065 185.192 308.626 182.333 308.941 178.527C310.096 164.602 294.149 143.269 273.323 130.879C257.517 121.475 243.442 119.926 237.072 125.813L217.944 136.466L284.521 200.353L304.597 187.14L304.538 187.084Z"
            />
          </mask>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M304.538 187.084C307.065 185.192 308.626 182.333 308.941 178.527C310.096 164.602 294.149 143.269 273.323 130.879C257.517 121.475 243.442 119.926 237.072 125.813L217.944 136.466L284.521 200.353L304.597 187.14L304.538 187.084Z"
            fill="#CFCBC3"
          />
          <path
            d="M308.941 178.527L310.934 178.692L308.941 178.527ZM304.538 187.084L303.339 185.483L301.426 186.915L303.173 188.546L304.538 187.084ZM273.323 130.879L274.346 129.16L273.323 130.879ZM237.072 125.813L238.045 127.561L238.253 127.444L238.429 127.282L237.072 125.813ZM217.944 136.466L216.971 134.718L214.606 136.035L216.559 137.909L217.944 136.466ZM284.521 200.353L283.137 201.796L284.288 202.901L285.621 202.024L284.521 200.353ZM304.597 187.14L305.697 188.811L307.82 187.413L305.962 185.678L304.597 187.14ZM306.948 178.362C306.674 181.67 305.353 183.975 303.339 185.483L305.736 188.685C308.776 186.41 310.577 182.997 310.934 178.692L306.948 178.362ZM272.301 132.598C282.49 138.66 291.485 146.914 297.773 155.325C304.12 163.815 307.464 172.133 306.948 178.362L310.934 178.692C311.572 170.996 307.521 161.685 300.977 152.93C294.373 144.096 284.983 135.489 274.346 129.16L272.301 132.598ZM238.429 127.282C240.997 124.909 245.397 123.806 251.398 124.595C257.351 125.377 264.562 127.994 272.301 132.598L274.346 129.16C266.278 124.36 258.549 121.5 251.92 120.629C245.34 119.764 239.517 120.83 235.714 124.344L238.429 127.282ZM218.917 138.213L238.045 127.561L236.099 124.066L216.971 134.718L218.917 138.213ZM285.906 198.91L219.328 135.023L216.559 137.909L283.137 201.796L285.906 198.91ZM303.498 185.469L283.422 198.683L285.621 202.024L305.697 188.811L303.498 185.469ZM303.173 188.546L303.232 188.602L305.962 185.678L305.902 185.622L303.173 188.546Z"
            fill="#766E68"
            mask="url(#path-18-inside-4)"
          />
          <path
            d="M290.018 190.167C289.471 196.759 284.958 200.536 277.751 201.039C270.568 201.54 260.874 198.759 250.379 192.516C239.885 186.273 230.663 177.799 224.235 169.2C217.785 160.572 214.293 152.033 214.839 145.441C215.386 138.849 219.899 135.073 227.106 134.57C234.289 134.068 243.983 136.849 254.478 143.092C264.972 149.336 274.194 157.809 280.622 166.408C287.072 175.036 290.564 183.576 290.018 190.167Z"
            fill="#EFEDEA"
            stroke="#766E68"
            stroke-width="2"
          />
          <path
            d="M272.57 180.941C272.293 184.286 269.991 186.294 266.143 186.563C262.318 186.83 257.129 185.348 251.49 181.993C245.852 178.639 240.916 174.097 237.494 169.518C234.049 164.911 232.281 160.482 232.559 157.137C232.836 153.791 235.138 151.784 238.986 151.515C242.811 151.248 248 152.729 253.639 156.084C259.277 159.439 264.213 163.981 267.635 168.559C271.079 173.166 272.848 177.596 272.57 180.941Z"
            fill="#766E68"
            stroke="#766E68"
            stroke-width="2"
          />
          <path
            d="M224.048 135.477C216.263 134.33 209.469 141.828 207.045 145.72C209.23 138.345 217.062 121.936 230.91 115.299C244.758 108.662 266.862 119.977 276.183 126.464L249.04 143.569C243.953 141.35 231.832 136.624 224.048 135.477Z"
            fill={mainColor}
            stroke={lineColor}
            stroke-width="2"
          />
          <path
            d="M224.048 135.477C216.263 134.33 209.469 141.828 207.045 145.72C209.23 138.345 217.062 121.936 230.91 115.299C244.758 108.662 266.862 119.977 276.183 126.464L249.04 143.569C243.953 141.35 231.832 136.624 224.048 135.477Z"
            fill={mainColor}
            stroke={lineColor}
            stroke-width="2"
          />
          <mask id="path-24-inside-5" fill="white">
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M230.134 232.697C232.661 230.805 234.221 227.946 234.537 224.14C235.692 210.215 219.745 188.882 198.919 176.492C183.113 167.088 169.038 165.538 162.668 171.426L143.54 182.079L210.117 245.966L230.193 232.753L230.134 232.697Z"
            />
          </mask>
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M230.134 232.697C232.661 230.805 234.221 227.946 234.537 224.14C235.692 210.215 219.745 188.882 198.919 176.492C183.113 167.088 169.038 165.538 162.668 171.426L143.54 182.079L210.117 245.966L230.193 232.753L230.134 232.697Z"
            fill="#CFCBC3"
          />
          <path
            d="M234.537 224.14L236.53 224.305L234.537 224.14ZM230.134 232.697L228.935 231.096L227.022 232.528L228.769 234.159L230.134 232.697ZM198.919 176.492L199.942 174.773L198.919 176.492ZM162.668 171.426L163.641 173.173L163.849 173.057L164.025 172.895L162.668 171.426ZM143.54 182.079L142.566 180.331L140.202 181.648L142.155 183.522L143.54 182.079ZM210.117 245.966L208.733 247.409L209.884 248.514L211.217 247.637L210.117 245.966ZM230.193 232.753L231.293 234.423L233.416 233.026L231.558 231.291L230.193 232.753ZM232.544 223.974C232.27 227.283 230.949 229.588 228.935 231.096L231.332 234.298C234.372 232.022 236.173 228.61 236.53 224.305L232.544 223.974ZM197.897 178.211C208.086 184.273 217.081 192.527 223.369 200.938C229.716 209.428 233.06 217.746 232.544 223.974L236.53 224.305C237.168 216.609 233.117 207.297 226.573 198.543C219.969 189.709 210.579 181.101 199.942 174.773L197.897 178.211ZM164.025 172.895C166.592 170.522 170.993 169.419 176.994 170.208C182.947 170.99 190.158 173.607 197.897 178.211L199.942 174.773C191.874 169.973 184.145 167.113 177.516 166.242C170.935 165.377 165.113 166.442 161.31 169.957L164.025 172.895ZM144.513 183.826L163.641 173.173L161.694 169.679L142.566 180.331L144.513 183.826ZM211.502 244.523L144.924 180.636L142.155 183.522L208.733 247.409L211.502 244.523ZM229.094 231.082L209.018 244.295L211.217 247.637L231.293 234.423L229.094 231.082ZM228.769 234.159L228.828 234.215L231.558 231.291L231.498 231.235L228.769 234.159Z"
            fill="#766E68"
            mask="url(#path-24-inside-5)"
          />
          <path
            d="M215.614 235.78C215.067 242.372 210.553 246.148 203.347 246.652C196.164 247.153 186.47 244.372 175.975 238.129C165.481 231.886 156.259 223.412 149.831 214.813C143.381 206.185 139.889 197.646 140.435 191.054C140.982 184.462 145.495 180.686 152.702 180.182C159.885 179.681 169.579 182.462 180.074 188.705C190.568 194.949 199.79 203.422 206.218 212.021C212.668 220.649 216.16 229.189 215.614 235.78Z"
            fill="#EFEDEA"
            stroke="#766E68"
            stroke-width="2"
          />
          <path
            d="M198.166 226.554C197.888 229.899 195.587 231.907 191.738 232.175C187.914 232.443 182.725 230.961 177.086 227.606C171.447 224.252 166.512 219.709 163.089 215.131C159.645 210.524 157.877 206.095 158.154 202.749C158.432 199.404 160.734 197.396 164.582 197.128C168.406 196.861 173.596 198.342 179.234 201.697C184.873 205.051 189.809 209.594 193.231 214.172C196.675 218.779 198.443 223.209 198.166 226.554Z"
            fill="#766E68"
            stroke="#766E68"
            stroke-width="2"
          />
          <path
            d="M177.595 91.3082C177.595 93.3031 175.389 94.9204 172.668 94.9204C169.946 94.9204 167.74 93.3031 167.74 91.3082C167.74 89.3132 167.74 66.7047 167.74 66.7047L177.595 66.7047C177.595 66.7047 177.595 90.2058 177.595 91.3082Z"
            fill="#CFCBC3"
            stroke="#766E68"
            stroke-width="2"
          />
          <path
            d="M177.594 65.9606C177.594 67.9556 175.388 69.5728 172.667 69.5728C169.946 69.5728 167.74 67.9556 167.74 65.9606C167.74 63.9656 169.946 62.3484 172.667 62.3484C175.388 62.3484 177.594 63.9656 177.594 65.9606Z"
            fill="#CFCBC3"
            stroke="#766E68"
            stroke-width="2"
          />
          <path
            d="M172.667 66.7046C173.989 66.7046 175.061 65.9191 175.061 64.95C174.421 63.0244 173.858 58.3537 176.726 56.7149V52.5154C174.575 53.0548 170.274 56.9524 170.274 64.95C170.274 65.9191 171.346 66.7046 172.667 66.7046Z"
            fill="#CFCBC3"
            stroke="#766E68"
            stroke-width="2"
          />
          <path
            d="M177.595 91.3082C177.595 93.3031 175.389 94.9204 172.668 94.9204C169.946 94.9204 167.74 93.3031 167.74 91.3082C167.74 89.3132 167.74 66.7047 167.74 66.7047L177.595 66.7047C177.595 66.7047 177.595 90.2058 177.595 91.3082Z"
            fill="#CFCBC3"
            stroke="#766E68"
            stroke-width="2"
          />
          <path
            d="M177.594 65.9606C177.594 67.9556 175.388 69.5728 172.667 69.5728C169.946 69.5728 167.74 67.9556 167.74 65.9606C167.74 63.9656 169.946 62.3484 172.667 62.3484C175.388 62.3484 177.594 63.9656 177.594 65.9606Z"
            fill="#CFCBC3"
            stroke="#766E68"
            stroke-width="2"
          />
          <path
            d="M172.667 66.7046C173.989 66.7046 175.061 65.9191 175.061 64.95C174.421 63.0244 173.858 58.3537 176.726 56.7149V52.5154C174.575 53.0548 170.274 56.9524 170.274 64.95C170.274 65.9191 171.346 66.7046 172.667 66.7046Z"
            fill="#CFCBC3"
            stroke="#766E68"
            stroke-width="2"
          />
          <path
            d="M62.417 88.5698L57.0908 46.7794L114.041 78.1222L168.942 45.1406L172.424 111.923L123.464 139.784L99.9055 126.673L62.417 88.5698Z"
            fill="#EFEDEA"
          />
          <path
            d="M114.041 78.1222L57.0908 46.7794L62.417 88.5698L99.9055 126.673L123.464 139.784M114.041 78.1222L123.464 139.784M114.041 78.1222L168.942 45.1406L172.424 111.923L123.464 139.784"
            stroke="#766E68"
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            d="M123.669 140.808L114.245 79.1465L169.146 46.1649L172.629 112.948L123.669 140.808Z"
            fill="#DEDBD6"
            stroke="#766E68"
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            d="M63.0315 47.5988L67.3961 86.5213C81.2415 93.9699 93.326 104.067 103.032 124.624L117.421 132.409L109.699 75.6279L63.0315 47.5988Z"
            fill="white"
            stroke="#766E68"
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            d="M128.205 133.228L120.839 81.3381L166.219 53.7445L167.901 91.4568L164.836 97.1738L161.772 85.497L137.394 100.451V128.517L128.205 133.228Z"
            fill="white"
            stroke="#766E68"
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            d="M62.417 88.5699L57.0908 46.7795L114.041 78.1223L168.942 45.1406L172.424 111.923L123.464 139.784L99.9055 126.673L62.417 88.5699Z"
            fill="#EFEDEA"
          />
          <path
            d="M114.041 78.1223L57.0908 46.7795L62.417 88.5699L99.9055 126.673L123.464 139.784M114.041 78.1223L123.464 139.784M114.041 78.1223L168.942 45.1406L172.424 111.923L123.464 139.784"
            stroke="#766E68"
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            d="M123.669 140.808L114.245 79.1465L169.146 46.1649L172.629 112.948L123.669 140.808Z"
            fill="#DEDBD6"
            stroke="#766E68"
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            d="M63.0315 47.5989L67.3961 86.5213C81.2415 93.97 93.326 104.067 103.032 124.624L117.421 132.409L109.699 75.6279L63.0315 47.5989Z"
            fill="white"
            stroke="#766E68"
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            d="M128.205 133.228L120.839 81.3381L166.219 53.7445L167.901 91.4569L164.836 97.1738L161.772 85.4971L137.394 100.451V128.517L128.205 133.228Z"
            fill="white"
            stroke="#766E68"
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            d="M116.499 84.6776C84.5794 61.283 70.2108 54.8736 49.7161 52.3105V46.3697L116.499 46.481L172.629 46.5746V52.5153L116.499 84.6776Z"
            fill={mainColor}
          />
          <path
            d="M116.499 84.6776C84.5794 61.283 70.2108 54.8736 49.7161 52.3105V46.3697L116.499 46.481M116.499 84.6776L172.629 52.5153V46.5746L116.499 46.481M116.499 84.6776V46.481"
            stroke={lineColor}
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            d="M116.499 77.3028C79.5843 50.4349 67.3232 47.4223 49.7161 46.5745L108.919 11.3395C132.374 10.5734 161.363 33.5848 172.629 46.7794L116.499 77.3028Z"
            fill={mainColor}
            stroke={lineColor}
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            d="M116.499 84.6776C84.5794 61.283 70.2108 54.8736 49.7161 52.3105V46.3697L116.499 46.481L172.629 46.5746V52.5153L116.499 84.6776Z"
            fill={mainColor}
          />
          <path
            d="M116.499 84.6776C84.5794 61.283 70.2108 54.8736 49.7161 52.3105V46.3697L116.499 46.481M116.499 84.6776L172.629 52.5153V46.5746L116.499 46.481M116.499 84.6776V46.481"
            stroke={lineColor}
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            d="M116.499 77.3028C79.5843 50.4349 67.3232 47.4223 49.7161 46.5745L108.919 11.3395C132.374 10.5734 161.363 33.5848 172.629 46.7794L116.499 77.3028Z"
            fill={mainColor}
            stroke={lineColor}
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            d="M140.672 127.858V102.295L158.858 90.296C159.917 89.5969 161.245 89.4415 162.436 89.881C186.436 98.7378 211.673 109.255 262.97 140.193L260.272 172.952C260.166 174.248 259.436 175.411 258.315 176.071L234.7 189.973C197.68 175.206 180.637 162.636 142.144 130.958C141.222 130.199 140.672 129.053 140.672 127.858Z"
            fill={mainColor}
          />
          <path
            d="M140.672 102.295V127.858C140.672 129.053 141.222 130.199 142.144 130.958C180.637 162.636 197.68 175.206 234.7 189.973M140.672 102.295L158.858 90.296C159.917 89.5969 161.245 89.4415 162.436 89.881C186.436 98.7378 211.673 109.255 262.97 140.193M140.672 102.295C166.074 125.853 191.885 141.422 229.374 162.318M262.97 140.193L229.374 162.318M262.97 140.193L260.272 172.952C260.166 174.248 259.436 175.411 258.315 176.071L234.7 189.973M229.374 162.318L234.7 189.973"
            stroke={lineColor}
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            d="M140.672 127.858V102.295L158.858 90.296C159.917 89.5969 161.245 89.4415 162.436 89.881C186.436 98.7378 211.673 109.255 262.97 140.193L260.272 172.952C260.166 174.248 259.436 175.411 258.315 176.071L234.7 189.973C197.68 175.206 180.637 162.636 142.144 130.958C141.222 130.199 140.672 129.053 140.672 127.858Z"
            fill={mainColor}
          />
          <path
            d="M140.672 102.295V127.858C140.672 129.053 141.222 130.199 142.144 130.958C180.637 162.636 197.68 175.206 234.7 189.973M140.672 102.295L158.858 90.296C159.917 89.5969 161.245 89.4415 162.436 89.881C186.436 98.7378 211.673 109.255 262.97 140.193M140.672 102.295C166.074 125.853 191.885 141.422 229.374 162.318M262.97 140.193L229.374 162.318M262.97 140.193L260.272 172.952C260.166 174.248 259.436 175.411 258.315 176.071L234.7 189.973M229.374 162.318L234.7 189.973"
            stroke={lineColor}
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            d="M261.946 152.382L261.024 161.806L253.649 165.87L242.485 172.253L232.754 177.989L224.253 173.073L223.638 167.644L231.115 170.819L239.392 165.87L253.649 157.401L261.946 152.382Z"
            fill="#F7F6F4"
          />
          <path
            d="M231.115 170.819L232.754 177.989M231.115 170.819L223.638 167.644L224.253 173.073L232.754 177.989M231.115 170.819L239.392 165.87M232.754 177.989L242.485 172.253M239.392 165.87L242.485 172.253M239.392 165.87L253.649 157.401M242.485 172.253L253.649 165.87M253.649 157.401L261.946 152.382L261.024 161.806L253.649 165.87M253.649 157.401V165.87"
            stroke="#766E68"
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            d="M261.946 152.382L261.024 161.806L253.649 165.87L242.485 172.253L232.754 177.989L224.253 173.073L223.638 167.644L231.115 170.819L239.392 165.87L253.649 157.401L261.946 152.382Z"
            fill="#F7F6F4"
          />
          <path
            d="M231.115 170.819L232.754 177.989M231.115 170.819L223.638 167.644L224.253 173.073L232.754 177.989M231.115 170.819L239.392 165.87M232.754 177.989L242.485 172.253M239.392 165.87L242.485 172.253M239.392 165.87L253.649 157.401M242.485 172.253L253.649 165.87M253.649 157.401L261.946 152.382L261.024 161.806L253.649 165.87M253.649 157.401V165.87"
            stroke="#766E68"
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            d="M120.801 192.022L99.4417 182.091C98.1999 181.514 97.3397 180.342 97.1619 178.984L92.6733 144.7L113.37 132.207C114.517 131.514 115.936 131.442 117.148 132.016L143.95 144.7V176.953C143.95 178.413 143.154 179.757 141.874 180.46L120.801 192.022Z"
            fill="#DEDBD6"
          />
          <path
            d="M120.801 192.022L99.4417 182.091C98.1999 181.514 97.3397 180.342 97.1619 178.984L92.6733 144.7M120.801 192.022L141.874 180.46C143.154 179.757 143.95 178.413 143.95 176.953V144.7M120.801 192.022V158.425M143.95 144.7L117.148 132.016C115.936 131.442 114.517 131.514 113.37 132.207L92.6733 144.7M143.95 144.7L120.801 158.425M92.6733 144.7L120.801 158.425"
            stroke="#766E68"
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            d="M117.148 132.016L143.95 144.7L120.801 158.425L92.6733 144.7L113.37 132.207C114.517 131.514 115.936 131.442 117.148 132.016Z"
            fill="#CFCBC3"
            stroke="#766E68"
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            d="M123.218 141.972C123.218 143.478 121.554 144.698 119.5 144.698C117.447 144.698 115.782 143.478 115.782 141.972C115.782 140.467 115.782 123.407 115.782 123.407L123.218 123.407C123.218 123.407 123.218 141.14 123.218 141.972Z"
            fill="#DEDBD6"
            stroke="#766E68"
            stroke-width="2"
          />
          <ellipse
            cx="119.5"
            cy="122.845"
            rx="3.71799"
            ry="2.72569"
            fill="#CFCBC3"
            stroke="#766E68"
            stroke-width="2"
          />
          <path
            d="M120.801 192.022L99.4417 182.091C98.1999 181.514 97.3397 180.342 97.1619 178.984L92.6733 144.7L113.37 132.207C114.517 131.514 115.936 131.442 117.148 132.016L143.95 144.7V176.953C143.95 178.413 143.154 179.757 141.874 180.46L120.801 192.022Z"
            fill="#DEDBD6"
          />
          <path
            d="M120.801 192.022L99.4417 182.091C98.1999 181.514 97.3397 180.342 97.1619 178.984L92.6733 144.7M120.801 192.022L141.874 180.46C143.154 179.757 143.95 178.413 143.95 176.953V144.7M120.801 192.022V158.425M143.95 144.7L117.148 132.016C115.936 131.442 114.517 131.514 113.37 132.207L92.6733 144.7M143.95 144.7L120.801 158.425M92.6733 144.7L120.801 158.425"
            stroke="#766E68"
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            d="M117.148 132.016L143.95 144.7L120.801 158.425L92.6733 144.7L113.37 132.207C114.517 131.514 115.936 131.442 117.148 132.016Z"
            fill="#CFCBC3"
            stroke="#766E68"
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            d="M123.218 141.972C123.218 143.478 121.554 144.698 119.5 144.698C117.447 144.698 115.782 143.478 115.782 141.972C115.782 140.467 115.782 123.407 115.782 123.407L123.218 123.407C123.218 123.407 123.218 141.14 123.218 141.972Z"
            fill="#DEDBD6"
            stroke="#766E68"
            stroke-width="2"
          />
          <ellipse
            cx="119.5"
            cy="122.845"
            rx="3.71799"
            ry="2.72569"
            fill="#CFCBC3"
            stroke="#766E68"
            stroke-width="2"
          />
          <path
            d="M120.839 192.022L99.4796 182.092C98.2377 181.514 97.3775 180.342 97.1998 178.984L92.7112 144.7L120.839 158.425V192.022Z"
            fill="#EFEDEA"
            stroke="#766E68"
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            d="M120.839 192.022L99.4796 182.092C98.2377 181.514 97.3775 180.342 97.1998 178.984L92.7112 144.7L120.839 158.425V192.022Z"
            fill="#EFEDEA"
            stroke="#766E68"
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            d="M45.824 113.562C31.7299 106.351 16.7004 106.153 11.3059 109.158L20.9771 94.1394L33.5327 85.7019C33.5327 85.7019 42.956 81.1951 56.0667 85.7019C85.4808 95.813 99.496 123.395 103.593 133.228L91.766 140.165L82.2882 145.724C77.9179 138.623 59.918 120.773 45.824 113.562Z"
            fill={mainColor}
          />
          <path
            d="M20.9771 94.1394L33.5327 85.7019C33.5327 85.7019 42.956 81.1951 56.0667 85.7019C85.4808 95.813 99.496 123.395 103.593 133.228L91.766 140.165M20.9771 94.1394L11.3059 109.158C16.7004 106.153 31.7299 106.351 45.824 113.562C59.918 120.773 77.9179 138.623 82.2882 145.724L91.766 140.165M20.9771 94.1394C28.9179 93.9217 46.8867 96.9885 59.3444 105.573C83.7221 122.371 85.807 132.663 91.766 140.165"
            stroke={lineColor}
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            d="M45.824 113.562C31.7299 106.351 16.7004 106.153 11.3059 109.158L20.9771 94.1394L33.5327 85.7019C33.5327 85.7019 42.956 81.1951 56.0667 85.7019C85.4808 95.813 99.496 123.395 103.593 133.228L91.766 140.165L82.2882 145.724C77.9179 138.623 59.918 120.773 45.824 113.562Z"
            fill={mainColor}
          />
          <path
            d="M20.9771 94.1394L33.5327 85.7019C33.5327 85.7019 42.956 81.1951 56.0667 85.7019C85.4808 95.813 99.496 123.395 103.593 133.228L91.766 140.165M20.9771 94.1394L11.3059 109.158C16.7004 106.153 31.7299 106.351 45.824 113.562C59.918 120.773 77.9179 138.623 82.2882 145.724L91.766 140.165M20.9771 94.1394C28.9179 93.9217 46.8867 96.9885 59.3444 105.573C83.7221 122.371 85.807 132.663 91.766 140.165"
            stroke={lineColor}
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            d="M160.133 172.048L137.394 184.954C142.236 172.125 146.865 166.838 157.265 159.552L160.133 172.048Z"
            fill={lineColor}
            stroke={lineColor}
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            d="M154.909 173.857C147.125 172.71 140.33 180.208 137.906 184.1C140.091 176.725 147.924 160.316 161.772 153.679C175.62 147.041 197.724 158.356 207.045 164.843L179.902 181.949C174.814 179.73 162.694 175.004 154.909 173.857Z"
            fill={mainColor}
            stroke={lineColor}
            stroke-width="2"
          />
          <path
            d="M160.133 172.048L137.394 184.954C142.236 172.125 146.865 166.838 157.265 159.552L160.133 172.048Z"
            fill={lineColor}
            stroke={lineColor}
            stroke-width="2"
            stroke-linejoin="round"
          />
          <path
            d="M154.909 173.857C147.125 172.71 140.33 180.208 137.906 184.1C140.091 176.725 147.924 160.316 161.772 153.679C175.62 147.041 197.724 158.356 207.045 164.843L179.902 181.949C174.814 179.73 162.694 175.004 154.909 173.857Z"
            fill={mainColor}
            stroke={lineColor}
            stroke-width="2"
          />
          <defs>
            <filter
              id="filter0_d"
              x="0.305664"
              y="0.820862"
              width="319.695"
              height="258.504"
              filterUnits="userSpaceOnUse"
              color-interpolation-filters="sRGB"
            >
              <feFlood flood-opacity="0" result="BackgroundImageFix" />
              <feColorMatrix
                in="SourceAlpha"
                type="matrix"
                values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                result="hardAlpha"
              />
              <feOffset dy="0.5" />
              <feGaussianBlur stdDeviation="0.5" />
              <feColorMatrix
                type="matrix"
                values="0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0 0.0705882 0 0 0 0.2 0"
              />
              <feBlend
                mode="normal"
                in2="BackgroundImageFix"
                result="effect1_dropShadow"
              />
              <feBlend
                mode="normal"
                in="SourceGraphic"
                in2="effect1_dropShadow"
                result="shape"
              />
            </filter>
          </defs>
        </svg>
      )}
    </div>
  );
}
export default Tractor;
